/*
LEANPATHの「仕入先内示テーブル」に表示されている情報(登録された取引情報)から、仕入先内示を作成するために必要なinterfaceをまとめたファイル
仕入先内示関連の型などはここに書くようにする
*/

/* TODO:リファクタ対象 */
/**
 * 仕入先内示エクセル出力を行うために使用する、列名 => IBusinessのkeyへの変換表
 * エクセルの列名が日本語(string)であるため、現状の仕様だと必要な為作成
 */
export const columnNameWithBusinessKeyRepresentMap = {
  仕入先名: 'supplierName',
  商品CD: 'businessNumber',
  商品名: 'businessName',
  売上先名: 'customerName',
  送り先名: 'salesDestinationName',
  置場名: 'warehouse',
  容量: 'package',
  内示: 'supplierForecasts',
  販売実績: 'salesResults',
  内訳: 'businessDetail', // TODO: こいつ合ってるか中身を確認する
};

/**
 * エクセルの出力先、出力前のアドレス情報と、その値を入れるための型
 */
export type ExcelExportResult = {
  [key: string]: {
    value: string | number | undefined; // エクセルのセルに書き込まれる値
    address: string | number | undefined; // 登録されるエクセルのアドレス
    colorInfo: object | string | boolean | undefined; // TODO: typesどっかから持って来れないか検討する
    borderInfo: object | string | boolean | undefined; // TODO: typesどっかから持って来れないか検討する
    boldInfo?: object | string | boolean | undefined;
  };
};

/**
 * システムから出力するエクセルの種類
 * 現状、出力する機能が仕入先内示しかないので一つだけだが、機能を増やす場合はこちらに追記する形で対応してください
 */
export type ExportFileType = '仕入先内示出力';
